import React from 'react';
import parse from "html-react-parser";
import WebLink from "../shared/WebLink";
import HelpImage from "./HelpImage";
import PageHeading from "../shared/PageHeading";

// Replace image references in the html with the HelpImage React component
const getImageComponent = domNode => {
  // const img = require(`../../assets/${domNode.attribs.src}`).default;
  const img = `https://storage.googleapis.com/citycad-online-assets/${domNode.attribs.src}`;

  return <HelpImage src={img} alt={domNode.attribs.src}/>
};

// If url is a number then assume it is another help article ID and open in the same window, otherwise open in new tab/window
const getTarget = url => {
  if (isUrlAnotherHelpFile(url))
    return "_self";
  else
    return "_blank";
};

const isUrlAnotherHelpFile = url => {
  return !isNaN(parseInt(url));
};

// Replace link references in the html with the WebLink React component.
const getWebLinkComponent = (domNode, navigate) => {

  // Return simple anchor node if no href attribute
  if (domNode.attribs.href === undefined) {
    return (
      <a href="#" key={domNode.attribs.name} name={`${domNode.attribs.name}`} />
    );
  }

  if (isUrlAnotherHelpFile(domNode.attribs.href)) {
    // Return link to CityCAD help article
    return (
      <WebLink key={`${Math.random()}${domNode.attribs.href}`} href={`${domNode.attribs.href}`}>
        {domNode.children.length > 0 && domNode.children[0].data}
      </WebLink>
    )
  }
  else {
    // Return link to external page
    return (
      <WebLink key={`${Math.random()}${domNode.attribs.href}`} href={`${domNode.attribs.href}`} target={getTarget(`${domNode.attribs.href}`)}>
        {domNode.children.length > 0 && domNode.children[0].data}
      </WebLink>
    );
  }
};


// Receive help article content HTML from urbandesigndatabase and insert links and images where needed
const processHelpArticleContent = (content, navigate) => {

  let parsedContent = parse(content, {
    replace: function (domNode) {
      if (domNode.name && domNode.name === "a")
        return getWebLinkComponent(domNode, navigate);
      if (domNode.name && domNode.name === "img")
        return getImageComponent(domNode);
    }
  });

  return parsedContent;
};

export default processHelpArticleContent;
